//@flow
/* #include 'include/Legacy.js' */
/* #include 'include/PasswordValidator.js' */

import { PasswordValidator } from "./include/PasswordValidator";

$(document).ready(function() {

  $(".logout-trigger").on('click', function(e) {
    e.preventDefault();

    $.get('/index.php?logout').done(function() {
      location.href = location.href;
    });
  });

  var policy_json = {
    Length: 6,
    Digits: 1,
    UpperCase: 1,
    LowerCase: 1,
    SpecialChars: 1,
    RepetitiveChars: 0
  };

  try {
    policy_json = JSON.parse($("#password-policy-json").text());
  } catch (e) {}

  var passwordValidator = new PasswordValidator($('form input[type=password]'), {
      Policy: policy_json,
      Fields: {
          EMail:'input[type=email]',
          FirstName:'input[name=name]',
          LastName: 'input[name=surname]',
          PolicyDescription: $("#password-policy-wrap")
      },

  });

  var renderPasswordErrors = function(errors) {
    var error_list  = $('input[type=password] + ul.error-list');
    error_list.html('');
    if (errors instanceof Array && errors.length) {
      errors.forEach(function (e) {
        error_list.append('<li>' + e + '</li>');
      });
    }
  }

  var onValidationResponse = function(response_obj) {
    if (response_obj.hasOwnProperty('Errors')) {
      renderPasswordErrors(response_obj.Errors);
    }
  }

  passwordValidator.registerResponseCB(onValidationResponse);

  var getPasswordField = function() {
    var password_policy = $('.password-policy');
    return {
      Length: password_policy.find('.length'),
      LowerCase: password_policy.find('.lower'),
      UpperCase: password_policy.find('.upper'),
      SpecialChars: password_policy.find('.special'),
      Digits: password_policy.find('.digits')
    }
  }

  $('form').on('keyup', 'input[type=password]', function() {
    var result = passwordValidator.getRulesResult($(this).val()),
    elements = getPasswordField();

    for (var key in elements) {
      if (elements.hasOwnProperty(key)) {
        if (result.Tests[key]) {
          elements[key].removeClass('not-passing');
          elements[key].addClass('passing');
        } else {
          elements[key].addClass('not-passing');
          elements[key].removeClass('passing');
        }
      }
    }

  });

  var slider = $('.row .quotes .slider-wrap ul').lightSlider({
    item: 1,
    loop: true,
    pause: 7000,
    speed: 600
  });

  setTimeout(function() {
    slider.play();
  }, 3000);

  $('.row.form').find('form').validate({
    onkeyup: function(element) {$(element).valid()},
    errorPlacement: function(element) {

        },
        highlight: function(element) {
            $(element)/*.closest('.form-group')*/.addClass('has-error');
        },
        unhighlight: function(element) {
            $(element)/*.closest('.form-group')*/.removeClass('has-error');
        },
    rules: {
      name: 'required',
      surname: 'required',
      email: 'required',
      company: 'required',
      tnc: 'required'
    }
  });

  $("#content > .row.col > .col-right > .nano").nanoScroller();

});